import {Injectable} from '@angular/core';
import {InsuranceCompanyCode} from '../models/insurance-company-code.enum';
import {ConfigurationService} from '../../core/services/impl/configuration/configuration.service';
import {InsuranceCompanyConfig} from '../../core/models/insurance-company-config';
import {InsuranceCompaniesConfig} from '../../core/configs/insurance-companies-config';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';

@Injectable({
  providedIn: 'root'
})
export class InsuranceCompanyService {

  private CONFIGS: InsuranceCompanyConfig[];

  constructor(private configurationService: ConfigurationService) {
    this.CONFIGS = (new InsuranceCompaniesConfig(this.configurationService)).createConfig();
  }

  getInsuranceCompanyConfig(code: InsuranceCompanyCode): InsuranceCompanyConfig {
    const config = this.CONFIGS.find(item => item.code === code);
    if (!isNotNullOrUndefined(config)) {
      console.warn(`No insurance company config for code ${code}.`);
    }
    return config;
  }

  getInsuranceCompanyName(code: InsuranceCompanyCode): string {
    const config = this.CONFIGS.find(item => item.code === code);
    return config ? config.name : null;
  }

  getInsuranceCompaniesForFilters(): InsuranceCompanyConfig[] {
    return this.CONFIGS.filter(config => !isNotNullOrUndefined(config.disabledInFilters) || !config.disabledInFilters);
  }

  getInsuranceCompaniesForOffersProgressDialog(): InsuranceCompanyConfig[] {
    return this.CONFIGS.filter(config => !isNotNullOrUndefined(config.disabledInOffersProgressDialog) || !config.disabledInOffersProgressDialog);
  }

  isGetOfferRequired(code: InsuranceCompanyCode): boolean {
    const icConfig = this.getInsuranceCompanyConfig(code);
    return isNotNullOrUndefined(icConfig.requiresGetOffer) ? icConfig.requiresGetOffer : false;
  }
}
